import { colorPalette } from '@/components/Theme/colors';
import { UniversalStatusGroupKey } from '@/mappers/jobStatuses';

type StatusColour = {
  [key in UniversalStatusGroupKey]: {
    backgroundColor: string;
    textColor: string;
    tableBorderColor: string;
    className: string;
  };
};

export const statusStyles: StatusColour = {
  [UniversalStatusGroupKey.PENDING]: {
    backgroundColor: colorPalette.orange.light,
    textColor: colorPalette.orange.main,
    tableBorderColor: colorPalette.orange.main,
    className: 'status-pending',
  },
  [UniversalStatusGroupKey.ON_HOLD]: {
    backgroundColor: colorPalette.grey.lighter,
    textColor: colorPalette.grey.dark,
    tableBorderColor: colorPalette.orange.main,
    className: 'status-on-hold',
  },
  [UniversalStatusGroupKey.IN_PROGRESS]: {
    backgroundColor: colorPalette.blue.trueblue.light,
    textColor: colorPalette.blue.trueblue.main,
    tableBorderColor: colorPalette.orange.main,
    className: 'status-in-translation',
  },
  [UniversalStatusGroupKey.RETURNED_BY_FTS]: {
    backgroundColor: colorPalette.purple.light,
    textColor: colorPalette.purple.main,
    tableBorderColor: colorPalette.orange.main,
    className: 'status-returned',
  },
  [UniversalStatusGroupKey.COMPLETED]: {
    backgroundColor: colorPalette.green.light,
    textColor: colorPalette.green.main,
    tableBorderColor: colorPalette.green.main,
    className: 'status-completed',
  },
  [UniversalStatusGroupKey.CALL_OUT_TO_USER]: {
    backgroundColor: colorPalette.red.light,
    textColor: colorPalette.red.main,
    tableBorderColor: colorPalette.red.main,
    className: 'status-cancelled',
  },
};
